import React, { useState, useEffect } from 'react';
import { promoCode } from '../data/mock';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const PromoBar = () => {
  const [settings, setSettings] = useState({
    enabled: true,
    text: promoCode.message
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${API_URL}/api/site-settings.php`);
        if (res.ok) {
          const data = await res.json();
          setSettings({
            enabled: data.promo_bar_enabled === '1',
            text: data.promo_bar_text || promoCode.message
          });
        }
      } catch (e) {
        // Koristi default vrednosti
      }
    };
    fetchSettings();
  }, []);

  if (!settings.enabled) return null;

  return (
    <div className="promo-bar">
      <p>{settings.text}</p>
    </div>
  );
};

export default PromoBar;
